import { IS_FLIPGIVE } from 'common/env';

export const FAVORITE = IS_FLIPGIVE ? 'Favourite' : 'Favorite';
export const FAVORITES = `${FAVORITE}s`;

/** Localize API-sourced security question text for FlipGive (Canadian/UK spelling). */
export const localizeSecurityQuestionText = (text: string): string => {
    if (!IS_FLIPGIVE) {
        return text;
    }

    const favorite = 'Favourite';
    const favorites = 'Favourites';

    return text
        .replace(/\bFavorites\b/g, favorites)
        .replace(/\bfavorites\b/g, favorites.toLowerCase())
        .replace(/\bFavorite\b/g, favorite)
        .replace(/\bfavorite\b/g, favorite.toLowerCase());
};
